import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import LinkButton from '../../../../../../components/LinkButton';
import ENDPOINT from '../../../../../../constants/endpoints';
import FileHelper from '../../../../../../helpers/file';
import useApi from '../../../../../../hooks/useApi';
import ResponseErrorDialog from '../../../../../Dialog/components/ResponseErrorDialog';

const TYPE = {
  ACTION_INTERESTED: 'interested',
  ACTION_NOT_INTERESTED: 'not interested',
  ACTION_CALENDAR: 'calendar',
};

const InboxAdditionalDataProcessSetupEmail = props => {
  const { actions, actionsToken, attachments } = props;

  const api = useApi();

  const links = useMemo(
    () =>
      actions.map(action => {
        let text = '';
        switch (action) {
          case TYPE.ACTION_INTERESTED:
            text = 'Interested In Role';
            break;
          case TYPE.ACTION_NOT_INTERESTED:
            text = 'Not Interested In Role';
            break;
          case TYPE.ACTION_CALENDAR:
            text = 'Schedule Call To Learn More';
            break;
          default:
            throw Error('Invalid Action prop');
        }
        if (action === TYPE.ACTION_INTERESTED) {
          text = 'Interested In Role';
        }

        if (action === TYPE.ACTION_NOT_INTERESTED) {
          text = 'Not Interested In Role';
        }

        if (action === TYPE.ACTION_CALENDAR) {
          text = 'Schedule Call To Learn More';
        }

        return (
          <div key={action} style={{ marginTop: '6px' }}>
            <LinkButton
              btnFontWeight={400}
              link={
                '/auth/process-email-actions?ActionName=' +
                action +
                '&ActionToken=' +
                actionsToken
              }
              text={text}
            />
          </div>
        );
      }),
    [actions]
  );

  const downloadFile = id => {
    api.download(
      ENDPOINT.ACTION.DOWNLOAD_PROCESS_SETUP_EMAIL_ATTACH,
      { id },
      {
        handleSuccess: response => {
          FileHelper.downloadInit(response.file, response.filename);
        },
        handleError: response => ResponseErrorDialog({ response }),
      }
    );
  };

  return (
    <div>
      <div>{links}</div>
      {attachments && attachments.length > 0 && (
        <div className="inbox-additional-data-process-setup-email-attach">
          <div className="inbox-additional-data-process-setup-email-attach--title">
            Files:
          </div>
          {attachments.map(item => (
            <div key={item.id} style={{ marginTop: '6px' }}>
              <LinkButton
                btnFontWeight={400}
                controlFunc={() => downloadFile(item.id)}
                text={item.name}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

InboxAdditionalDataProcessSetupEmail.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string).isRequired,
  actionsToken: PropTypes.string.isRequired,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string.isRequired,
    })
  ),
};

export default InboxAdditionalDataProcessSetupEmail;
